import React, { PureComponent } from 'react'
import styled from 'styled-components'


export default class Viewers extends PureComponent {
  render() {

    const playMovie = (e) => {
      e.target.play();
      console.log('on');
    }
    return (
      <Container>
        <Wrap>
          <img src='/images/viewers-disney.png' />
          <video onMouseOver={playMovie} >

            <source src='/videos/1564674844-disney.mp4' type="video/mp4" />
          </video>
        </Wrap>
        <Wrap>
          <img src='/images/viewers-pixar.png' />
          <video onMouseOver={playMovie} >

            <source src='videos/1564676714-pixar.mp4' type="video/mp4" />
          </video>
        </Wrap>
        <Wrap>
          <img src='/images/viewers-marvel.png' />
          <video onMouseOver={playMovie} >

            <source src='/videos/1564676115-marvel.mp4' type="video/mp4" />
          </video>
        </Wrap>
        <Wrap>
          <img src='/images/viewers-starwars.png' />
          <video onMouseOver={playMovie} >

            <source src='/videos/1608229455-star-wars.mp4' type="video/mp4" />
          </video>
        </Wrap>
        <Wrap>
          <img src='/images/viewers-national.png' />
          <video onMouseOver={playMovie} >

            <source src='/videos/1564676296-national-geographic.mp4' type="video/mp4" />
          </video>
        </Wrap>

      </Container>
    )
  }
}
const Container = styled.div`
// padding: 0 0 26px;
margin-top:30px;
padding: 30px 0px 26px;
display: grid;
grid-gap: 25px;
grid-template-columns: repeat(5, minmax(0, 1fr));

`
const Wrap = styled.div`
border-radius: 10px;
cursor:pointer;
border: 3px solid rgba(249,249,249,0.1);
box-shadow: rgba(0 0 0 / 69%) 0px 26px 30px -10px,
rgb(0 0 0 / 73%) 0px 16px 10px -10px;
transition: all 250ms cubic-bezier(0.25,0.46,.45,.94) 0s;
img{
  width:100%;
  height:100%;
  object-fit:cover;
}
video{
  width:100%;
  height:100%;
  object-fit:cover;
  display: none;
}
&:hover img{
  
  display: none;
  
}
&:hover video{
  
  display: flex;
  
}

&:hover{
  box-shadow: rgba(0 0 0 / 80%) 0px 40px 58px -16px,
  rgb(0 0 0 / 73%) 0px 30px 22px -10px;
  transform: scale(1.05);
  border-color: rgba(249,249,249,0.8);


  
}

/* const VideoController = function(isHovering, videoElement)
{
	if (isHovering == true)
    {
        
    }
    else if (isHovering == false)
    {
        videoElement.pause();
    }
} */
`